// Import package
import React from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

// Import file
import PageContentWrapper from "../../components/PageContentWrapper";
import TrainingCategoriesListContainer from "../../containers/adminRole/trainingCategories/TrainingCategoriesListContainer";

// Component
export default function TrainingCategoriesPage() {
  return (
    <PageContentWrapper
      title="Kategori Training"
      extra={
        <Link to="/training-category/add">
          <Button icon={<PlusOutlined />} type="primary" style={{ margin: 0 }}>
            Tambah
          </Button>
        </Link>
      }
    >
      <TrainingCategoriesListContainer />
    </PageContentWrapper>
  );
}
